import { CarbonCredit } from 'src/app/shared/interfaces/carbon-credit';

export type CarbonCreditTypeBadgeTone = 'info' | 'success' | 'danger' | 'warning' | 'default';

export interface CarbonCreditTypeBadge {
  label: string;
  icon: string;
  tone: CarbonCreditTypeBadgeTone;
}

const DEPOSIT_INSTRUMENT_CODES = new Set(['CARB', 'DEPOSIT']);

export function resolveCarbonCreditTypeBadge(credit: CarbonCredit): CarbonCreditTypeBadge {
  const instrumentCode = credit.financialInstrumentTypeCode?.trim().toUpperCase() ?? '';

  if (DEPOSIT_INSTRUMENT_CODES.has(instrumentCode) || !instrumentCode) {
    return {
      label: 'Depósito',
      icon: 'check_circle',
      tone: 'success',
    };
  }

  if (instrumentCode === 'TRANSFER' || instrumentCode === 'TRANSFER_WITHOUT_FINANCIAL') {
    return {
      label: 'Transferência',
      icon: 'swap_horiz',
      tone: 'warning',
    };
  }

  if (instrumentCode === 'WITHDRAW') {
    return {
      label: 'Retirada',
      icon: 'logout',
      tone: 'warning',
    };
  }

  if (instrumentCode === 'TRADE_TO') {
    return {
      label: 'Compra - ACX',
      icon: 'currency_exchange',
      tone: 'info',
    };
  }

  if (instrumentCode === 'TRADE_FROM') {
    return {
      label: 'Venda - ACX',
      icon: 'currency_exchange',
      tone: 'info',
    };
  }

  if (instrumentCode === 'RETIREMENT') {
    return {
      label: 'Aposentadoria - ACX',
      icon: 'check_circle',
      tone: 'info',
    };
  }

  if (instrumentCode === 'DELIVERY') {
    return {
      label: 'Retirada - ACX',
      icon: 'logout',
      tone: 'info',
    };
  }

  return {
    label: instrumentCode,
    icon: 'info',
    tone: 'default',
  };
}
